/*
 * scripts.js - List out the ISO 15924 script codes
 *
 * Copyright © 2022 JEDLSoft
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

export const iso15924 = {
    "scripts": [
        "Adlm",
        "Afak",
        "Aghb",
        "Ahom",
        "Arab",
        "Aran",
        "Armi",
        "Armn",
        "Avst",
        "Bali",
        "Bamu",
        "Bass",
        "Batk",
        "Beng",
        "Bhks",
        "Blis",
        "Bopo",
        "Brah",
        "Brai",
        "Bugi",
        "Buhd",
        "Cakm",
        "Cans",
        "Cari",
        "Cham",
        "Cher",
        "Chrs",
        "Cirt",
        "Copt",
        "Cpmn",
        "Cprt",
        "Cyrl",
        "Cyrs",
        "Deva",
        "Diak",
        "Dogr",
        "Dsrt",
        "Dupl",
        "Egyd",
        "Egyh",
        "Egyp",
        "Elba",
        "Elym",
        "Ethi",
        "Geok",
        "Geor",
        "Glag",
        "Gong",
        "Gonm",
        "Goth",
        "Gran",
        "Grek",
        "Gujr",
        "Guru",
        "Hanb",
        "Hang",
        "Hani",
        "Hano",
        "Hans",
        "Hant",
        "Hatr",
        "Hebr",
        "Hira",
        "Hluw",
        "Hmng",
        "Hmnp",
        "Hrkt",
        "Hung",
        "Inds",
        "Ital",
        "Jamo",
        "Java",
        "Jpan",
        "Jurc",
        "Kali",
        "Kana",
        "Khar",
        "Khmr",
        "Khoj",
        "Kitl",
        "Kits",
        "Knda",
        "Kore",
        "Kpel",
        "Kthi",
        "Lana",
        "Laoo",
        "Latf",
        "Latg",
        "Latn",
        "Leke",
        "Lepc",
        "Limb",
        "Lina",
        "Linb",
        "Lisu",
        "Loma",
        "Lyci",
        "Lydi",
        "Mahj",
        "Maka",
        "Mand",
        "Mani",
        "Marc",
        "Maya",
        "Medf",
        "Mend",
        "Merc",
        "Mero",
        "Mlym",
        "Modi",
        "Mong",
        "Moon",
        "Mroo",
        "Mtei",
        "Mult",
        "Mymr",
        "Nand",
        "Narb",
        "Nbat",
        "Newa",
        "Nkdb",
        "Nkgb",
        "Nkoo",
        "Nshu",
        "Ogam",
        "Olck",
        "Orkh",
        "Orya",
        "Osge",
        "Osma",
        "Palm",
        "Pauc",
        "Perm",
        "Phag",
        "Phli",
        "Phlp",
        "Phlv",
        "Phnx",
        "Plrd",
        "Piqd",
        "Prti",
        "Qaaa",
        "Qabx",
        "Rjng",
        "Rohg",
        "Roro",
        "Runr",
        "Samr",
        "Sara",
        "Sarb",
        "Saur",
        "Sgnw",
        "Shaw",
        "Shrd",
        "Shui",
        "Sidd",
        "Sind",
        "Sinh",
        "Sogd",
        "Sogo",
        "Sora",
        "Soyo",
        "Sund",
        "Sylo",
        "Syrc",
        "Syre",
        "Syrj",
        "Syrn",
        "Tagb",
        "Takr",
        "Tale",
        "Talu",
        "Taml",
        "Tang",
        "Tavt",
        "Telu",
        "Teng",
        "Tfng",
        "Tglg",
        "Thaa",
        "Thai",
        "Tibt",
        "Tirh",
        "Toto",
        "Ugar",
        "Vaii",
        "Visp",
        "Wara",
        "Wcho",
        "Wole",
        "Xpeo",
        "Xsux",
        "Yezi",
        "Yiii",
        "Zanb",
        "Zinh",
        "Zmth",
        "Zsye",
        "Zsym",
        "Zxxx",
        "Zyyy",
        "Zzzz"
    ]
}